import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/fonts/material-icon/css/material-design-iconic-font.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
// import VueBlobJsonCsv from 'vue-blob-json-csv'
// import URL from './url'
import 'sweetalert2/dist/sweetalert2.min.css';


const app = createApp(App)
app.use(VueSweetalert2)
app.use(router)
// app.use(VueBlobJsonCsv);
// app.use(URL)
app.mount('#app')

